import withModal from '@/Components/Modals/withModalHOC';
import Modal from '@/Components/UI/Modal/Modal';

import { MODAL_LIVE_QUERY } from '@/Utils/constants';

const LiveQueryModal = ({ show, hideModal }) => {
  return (
    <Modal
      title='Live Query'
      isOpen={show}
      onClose={hideModal}
      iconName='database'
      modalTitleClasses='!p-0'
    >
      <p className='mx-1 mb-6' data-cy='live-query-modal'>
        You cannot edit the data in this sheet, but you can still change the view on the sheet, such
        as sorts, filters and groups.
      </p>
    </Modal>
  );
};

export default withModal({ name: MODAL_LIVE_QUERY })(LiveQueryModal);
